module.exports = "/_next/static/images/advantages-box-3e8433d9c981fafec9245b15dc241d9f.svg";